// useProfileRelease.ts
import { Participant, ParticipantActivityType, ParticipantStatus, Project, Trainer } from "../../types/PersologOnlineTypes.ts";
import { ProfileAdministrationAPI } from "../../api";
import { sendProfileEmail } from "../EmailUtils.ts";
import { ref } from "vue";

export default function useProfileShare(participant: Participant, project: Project, trainer: Trainer) {
    const loading = ref(false);

    async function shareProfile() {
        loading.value = true;
        const receiver = await ProfileAdministrationAPI.updateParticipant({
            id: participant.id,
            status: ParticipantStatus.NOTIFIED,
            gender: participant.gender,
            email: participant.email,
            firstName: participant.firstName,
            name: participant.name,
            questionnaire: participant.questionnaire,
            projectId: participant.projectId,
            selectedProduct: participant.selectedProduct,
            departmentId: participant.departmentId,
            roleId: participant.roleId,
            deletionDate: participant.deletionDate,
            score: participant.score,
        });
        await sendProfileEmail(trainer, receiver, project);
        await ProfileAdministrationAPI.logParticipantActivity(participant.id!, ParticipantActivityType.PROFILE_SHARED);
        loading.value = false;
    }

    return {
        shareProfile,
        loading,
    };
}
